var ezdia;
(function (ezdia) {
    var navtoggleHtml = "<button class=\"navbar-toggle collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#ez-navbar-collapse\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"fa fa-circle\"></span>\n        <span class=\"fa fa-circle\"></span>\n        <span class=\"fa fa-circle\"></span>\n    </button>";
    function navItemContent(_a) {
        var name = _a.name, label = _a.label, icon = _a.icon, isActive = _a.is_active, url = _a.url, onclick = _a.onclick, children = _a.children;
        var htmlContent = '';
        if (name === 'divider') {
            htmlContent = "<li class=\"divider\"></li>";
        }
        else {
            var cls = isActive ? 'active ' : '';
            var linkAttr = '';
            var caret = '';
            var childrenItems = '';
            if (children && children.length) {
                cls += 'dropdown';
                linkAttr = "class=\"dropdown-toggle\" data-toggle=\"dropdown\"";
                caret = "<span class=\"caret\"></span>";
                childrenItems = "<ul class=\"dropdown-menu\">\n        " + navMenuItems(children) + "\n      </ul>";
            }
            htmlContent = "<li id=\"ez-top-nav-menu-" + name + "\" class=\"" + cls + "\">\n        <a href=\"" + (url || "javascript:void(0)") + "\" " + linkAttr + " " + (onclick ? "onclick=\"" + onclick + "\"" : '') + ">\n          <span class=\"" + icon + "\"></span>\n          <span class=\"desk-nav-title\">" + label + caret + "</span>\n        </a>" + childrenItems + "\n      </li>";
        }
        return htmlContent;
    }
    function navMenuItems(navItems) {
        var htmlContent = navItems.map(function (navItem) {
            return navItemContent(navItem);
        });
        return htmlContent.join('');
    }
    function getMarkup(navItems) {
        var _a = ezdia.config, _b = _a.user, fullUrl = _b.full_url, logo = _b.logo, accountLogo = _a.pageParams.accountLogo;
        return "<div class=\"shadow-navbar\"></div>\n      <nav class=\"navbar no-radius desk-nav\" role=\"navigation\" id=\"ez-page-top-navbar\">\n        <div class=\"container-fluid\">\n          <div class=\"pull-left\">\n            <a class=\"navbar-brand\" href=\"" + fullUrl + "/desk/Home.htm\">\n              " + (logo
            ? "<img hspace=\"20\" class=\"ezdia-logo\" style=\"margin-right:17px;\" src=\"" + logo + "\">"
            : '') + "<img class=\"ezdia-logo\" src=\"" + accountLogo + "\">\n            </a>\n          </div>\n          " + navtoggleHtml + "\n          <ul id=\"ez-navbar-collapse\" class=\"navbar-header list-unstyled pull-right\">\n            " + navMenuItems(navItems) + "\n          </ul>\n        </div>\n      </nav>\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.navbar = {
            getMarkup: getMarkup
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
